import * as types from "./sign-up.types";

const initialState = {
	step_1: null,
	step_2: null,
};

export default function sign_up_reducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_STEP_1:
			return {
				...state,
				step_1: action.payload,
			};
		case types.SET_STEP_2:
			return {
				...state,
				step_2: action.payload,
			};

		default:
			return state;
	}
}
